import React, { Component } from "react";
import Caption from "../Caption";
import { formatBytes } from "../../../../Helpers/Chat/ChatHelper";
import PropTypes from "prop-types";

export default class PreviewDocument extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.props.updateMedia(this.props.media, {
      msgType: "file"
    });
  }

  render() {
    const {
      media: { name = "", size = "" } = {},
      placeholder,
      onChangeCaption,
      onClickSend,
      uniqueId,
      chatType,
      chatId,
      selectedFiles,
      type
    } = this.props;
    const updateSize = formatBytes(size);

    return (
        <div className="type-image document">
          <div className="type-thumb-image">
            <img src={placeholder} alt="" />
            <p>{`${name} , ${updateSize}`}</p>
          </div>
          <Caption
            onChangeCaption={onChangeCaption}
            media={this.props.media}
            onClickSend={onClickSend}
            uniqueId={uniqueId}
            selectedFiles={selectedFiles}
            chatType={chatType}
            chatId={chatId}
            newFile={type}
          />
        </div>
    );
  }
}

PreviewDocument.propTypes = {
  updateMedia: PropTypes.func.isRequired,
  media: PropTypes.shape({
    name: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  placeholder: PropTypes.string,
  onChangeCaption: PropTypes.func,
  onClickSend: PropTypes.func,
  uniqueId: PropTypes.string,
  selectedFiles: PropTypes.array,
  chatType: PropTypes.string,
  chatId: PropTypes.string,
  type: PropTypes.string,
};
